export default function initialState() {
    return {
        _cached_dispatch_fn_: null
    };
}
